"use client";
import React from "react";
import { Tooltip } from "@nextui-org/react";

const DataMatchLatestComponent = ({ match, matchLatest }) => {
  const {homeMatches, awayMatches} = matchLatest
  const transferTimetamp = (time, type='default') => {
    const date = new Date(time * 1000);
    const options = {
      day: '2-digit',
      month: '2-digit'
    };
    if (type !== 'default') {
      const currentDate = new Date();

      const timeDifference = date - currentDate;
      const daysLeft = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      return `${daysLeft} Ngày`;
    }
    return date.toLocaleString('vi-VN', options).replace('-', '/');
  }

  const handleTeam = (teamId, matchTeamId) => {
    if (teamId === matchTeamId?.homeId) return 'Chủ';
    if (teamId === matchTeamId?.awayId) return 'Khách';
  };

  const handleTeamName = (type, matchTeamId) => {
    if (type === "Chủ") return matchTeamId?.awayName;
    else return matchTeamId?.homeName;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 max-w-[816px] mt-5 mb-[24px] m-auto gap-[16px] [&>*]:rounded-[4px]">
      <div className="bg-header-blue dark:bg-dark-slate">
        <div
          className="home_name rounded-[4px] rounded-bl-none bg-custom-gradient-recent-lineup text-sm pl-[33px] pt-[3px] text-white w-max pr-[32px]">
          {match.homeName}
        </div>
        <div
          className="bg-royal-blue px-[20px] dark:bg-pure-black dark:text-stroke-o3 font-bold text-white py-[6px] text-[10px] grid grid-cols-12 gap-1 [&>*]:text-center">
          <div className={'col-span-2'}>Giải đấu</div>
          <div>Ngày</div>
          <div className={'col-span-3'}>Kiểu</div>
          <div className={'col-span-3'}>VS</div>
          <div className={'col-span-3'}>Trận đấu đang</div>
        </div>
        <div className={'m-[9px] flex flex-col gap-1'}>
          {homeMatches.map(item => (
            <div className=" py-1 px-2 grid grid-cols-12 gap-1 [&>*]:text-center text-xxs bg-white dark:bg-midnight-slate rounded ">
              <div className={'col-span-2'}>{item.league.shortName}</div>
              <div>{transferTimetamp(item.matchTime)}</div>
              <div className={'col-span-3'}>{handleTeam(match.homeId, item)}</div>
              <Tooltip
                showArrow={true}
                content={handleTeamName(handleTeam(match.homeId, item), item)}
                className="bg-header-blue text-button-blue-bet rounded px-2"
              >
                <div className={'col-span-3 line-clamp-1'}>{handleTeamName(handleTeam(match.homeId, item), item)}</div>

              </Tooltip>
              <div className={'col-span-3'}>{transferTimetamp(item.matchTime, 'day')}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-[#FFFCEC] dark:bg-dark-slate">
        <div
          className="home_name ml-auto text-right rounded-[4px] rounded-br-none bg-custom-gradient-recent-lineup-away text-sm pl-[33px] pt-[3px] text-button-blue-bet w-max pr-[22px]">
          {match.awayName}
        </div>
        <div
          className="bg-semi-transparent-golden-yellow dark:bg-pure-black dark:text-stroke-o3 px-[20px] font-bold text-button-blue-bet  py-[6px] text-[10px] grid grid-cols-12 gap-1 [&>*]:text-center">
          <div className={'col-span-2'}>Giải đấu</div>
          <div>Ngày</div>
          <div className={'col-span-3'}>Kiểu</div>
          <div className={'col-span-3'}>VS</div>
          <div className={'col-span-3'}>Trận đấu đang</div>
        </div>
        <div className={'m-[9px] flex flex-col gap-1 '}>
          {awayMatches.map(item => (
            <div className=" py-1 px-2 grid grid-cols-12 gap-1 [&>*]:text-center text-xxs bg-white dark:bg-midnight-slate rounded ">
              <div className={'col-span-2'}>{item.league.shortName}</div>
              <div>{transferTimetamp(item.matchTime)}</div>
              <div className={'col-span-3'}>{handleTeam(match.awayId, item)}</div>
              <Tooltip
                showArrow={true}
                content={handleTeamName(handleTeam(match.awayId, item), item)}
                className="bg-header-blue text-button-blue-bet rounded px-2"
              >
                <div className={'col-span-3 line-clamp-1'}>{handleTeamName(handleTeam(match.awayId, item), item)}</div>

              </Tooltip>
              <div className={'col-span-3'}>{transferTimetamp(item.matchTime, 'day')}</div>
            </div>
          ))}
        </div>
      </div>


    </div>
  );
};

export default React.memo(DataMatchLatestComponent);

